// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"794":"4c1f3d92","930":"5225b08b","947":"79e4dbe2"}[chunkId] + ".chunk.js";
};